import React, { useRef } from 'react';

// Navigation clavier d'une liste d'onglets (motif WAI-ARIA « tabs ») :
// flèches gauche/droite (et haut/bas), Début et Fin activent l'onglet voisin
// et lui donnent le focus. À utiliser avec un tabIndex itinérant
// (0 sur l'onglet actif, -1 sur les autres).
export function useTabsKeyboard<K extends string>(
  keys: K[],
  active: K,
  onSelect: (key: K) => void,
) {
  const refs = useRef(new Map<K, HTMLButtonElement | null>());

  const register = (key: K) => (el: HTMLButtonElement | null) => {
    refs.current.set(key, el);
  };

  const onKeyDown = (e: React.KeyboardEvent) => {
    const index = keys.indexOf(active);
    if (index < 0 || keys.length === 0) return;
    let next = index;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (index + 1) % keys.length;
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (index - 1 + keys.length) % keys.length;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = keys.length - 1;
    else return;
    e.preventDefault();
    const key = keys[next];
    onSelect(key);
    refs.current.get(key)?.focus();
  };

  return { register, onKeyDown };
}
